import { Component } from '@angular/core';
import {Router, ActivatedRoute, NavigationStart} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'ng-app';
  constructor(private router: Router, private activatedRouter: ActivatedRoute){}
  ngOnInit(){
    this.router.events.subscribe(event =>{
if (event instanceof NavigationStart){
      console.log(event.url)
      this.routerChangeMethod(event.url);
    }
    })
  }
  routerChangeMethod(url: string){
    let profile = localStorage.getItem('PROFILE');
    console.log("Navigating to URL: " +url)
    if (profile) {
      console.log('Profile present');
      let screenWidth = screen.width;
      console.log('Screen width '+ screenWidth);
      
      if (screen.width > 970) {
        document.querySelector<HTMLElement>( ".enable-on-login" ).style.display= "inline-block" ;
      }else {
        document.querySelector<HTMLElement>( ".enable-on-login" ).style.display= "block";
      }

      document.querySelector<HTMLElement>( ".disable-on-login").style.display= "none";

    } else {
      console.log('Profile not present ');
      if (screen.width > 970) {
        document.querySelector<HTMLElement>( ".disable-on-login").style.display= "inline-block";
      }else {
        document.querySelector<HTMLElement>( ".disable-on-login").style.display= "block";
      }

      document.querySelector<HTMLElement>( ".enable-on-login" ).style.display= "none";
    }

    
    let button = document.getElementById('video-floating-button');
    if (!button) {
      button = document.createElement("div");
      button.id = 'video-floating-button';
      button.innerHTML = '<i class="fusion-li-icon fa fa-video-camera"></i><div>GUARDA IL VIDEO</div>';
      button.className = 'video-floating-button';
      document.body.appendChild(button);
    }
    
    let requestUrl = url;
    console.log("is area riservata: " + requestUrl.endsWith('areariservata'))
    if (requestUrl.endsWith('areariservata')
      || requestUrl.includes('areariservata?tabToLoad=tenderDetail')
      || requestUrl.includes('areariservata?tabToLoad=dashboard') 
      || requestUrl.endsWith('gareincorso')
      || requestUrl.endsWith('creaunagara')
      || requestUrl.endsWith('aziende')
      || requestUrl.endsWith('professionisti')
     // || requestUrl.endsWith('richiestapreventivo')
     // || requestUrl.includes('acquistacreazionegara')
      || requestUrl.includes('acquistapartecipazioneallagara')
      ) {
      document.querySelector<HTMLElement>('#' + button.id).style.visibility= 'visible';
      document.querySelector<HTMLElement>('#' + button.id).onclick = function() {
        requestUrl = window.location.href;
        console.log('Video URL: ' + requestUrl)
        if (requestUrl.endsWith('areariservata') 
          || requestUrl.includes('areariservata?tabToLoad=dashboard')) {
          window.open('https://youtu.be/ruzKR1su7jA','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=tenders')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=tenderDetail')){
          window.open('https://youtu.be/dA3JIFfQIgM','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=myParticipations')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=participationDetail')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=profile')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=paymentMethod')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('areariservata?tabToLoad=prepaidPackets')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('gareincorso')){
          window.open('https://youtu.be/EM6ui8XCZf4','_blank')
        }else if (requestUrl.includes('acquistapartecipazioneallagara')){
          window.open('https://youtu.be/XUwgqRy_jJU','_blank')
        }else if (requestUrl.includes('creaunagara')){
          window.open('https://youtu.be/MXEsxkfnY1k','_blank')
        }else if (requestUrl.includes('acquistacreazionegara')){
          window.open('https://www.google.it','_blank')
        }else if (requestUrl.includes('aziende')){
          window.open('https://youtu.be/IoD1oMPrWTw','_blank')
        }else if (requestUrl.includes('professionisti')){
          window.open('https://youtu.be/pI2y2P2ROuU','_blank')
        }else {
          console.log("Url " + requestUrl + " hasn't got a mapped video")
        }
        
      };
    } else {
      document.querySelector<HTMLElement>('#' + button.id).style.visibility = 'hidden';
    }   
  }
}
